module.exports = __webpack_public_path__ + "img/GALLERY-BALENO-1.9337f576.jpg";